import {useEffect} from "react";
import {useNavigate} from 'react-router-dom';

export let AdminFrameRoot = function () {
    let navigate = useNavigate();

    // redirect to default page on mount. Can route to different pages depending on user role if necessary.
    useEffect(function () {
        goToDefaultPage();
    }, []);

    function goToDefaultPage() {
        navigate('/dashboard');
    }

    return null;
};
